import {InvalidDraftError} from './InvalidDraftError.js'
import {NotFoundDraftError} from './NotFoundDraftError.js'
import {PublishDraftError} from './PublishDraftError.js'

export class DraftErrorsFactory {
  static invalidDraftError = data => new InvalidDraftError(data)
  static notFoundDraftError = ({message}) => new NotFoundDraftError(message)

  static publishDraftError = message => new PublishDraftError(message)
}
